module.exports = __webpack_public_path__ + "static/media/sagar-full.6f581428.png";